import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MassAttachDatas } from 'src/app/shared/interfaces/scans/mass-attach-datas';
import { Scan as ScanDTO } from 'src/app/shared/models/iScanAPI/scan';
import { IScanAPIService } from 'src/app/shared/services/iscan.service';
import { AttachScanToExistingMailComponentParams } from 'src/app/shared/models/iCourrier/scans/attach-scan-to-mail';
import { ICourrierScanService } from 'src/app/shared/services/iCourrier-scan.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MailsService } from 'src/app/shared/services/mails.service';
import { ScanSearchMailsForBatchAttachment } from 'src/app/shared/models/iCourrier/scans/scan-search-mails';
import { TranslateService } from '@devinforius/i-essentials';
import { Scan } from '@devinforius/i-scan';

@Component({
  selector: 'app-mass-attach-scans',
  templateUrl: './mass-attach-scans.component.html',
  styleUrls: ['./mass-attach-scans.component.scss'],
})
export class MassAttachScansComponent implements OnInit {
  @Input() public originScan: ScanDTO;
  @Input() public scan: Scan;

  @Output() public closeModal: EventEmitter<null | ScanSearchMailsForBatchAttachment[]> = new EventEmitter();

  public displayedDatas: MassAttachDatas[];
  public expressionReguliereWithiCourrierID = new RegExp('ECOURRIER(\\s|.)*\\*ID > (\\d*)(\\s|.)*');

  public allCardsSelected = false;

  public isLoaded: boolean = false;
  public submitAttachmentLoader: boolean = false;

  constructor(
    private translater: TranslateService,
    private spinner: NgxSpinnerService,
    private iScanAPIService: IScanAPIService,
    private iCourrierScanService: ICourrierScanService,
    private toastr: ToastrService,
    private router: Router,
    private mailsService: MailsService
  ) {}

  ngOnInit(): void {
    this.setDatasForCardsDisplayed();
  }

  private setDatasForCardsDisplayed(): void {
    this.displayedDatas = [];
    this.scan.splits.forEach((split, splitIndex) => {
      if (!split.lock) {
        // Pour chaque split NON LOCK, on va récupérer le QRCode ainsi que les données lui étant liées
        // un split lock signifie qu'un courrier a déjà été créé
        const qrCode = this.explodeQrCodeToFindIDCourrier(split.mainCode);
        const dataForCard: MassAttachDatas = {
          splitIndex: splitIndex,
          courrierIndex: splitIndex + 1,
          idCourrierFile: qrCode,
          isChecked: qrCode ? true : false,
        };
        this.displayedDatas.push(dataForCard);
      }
    });
    this.displayedDatas = [...this.displayedDatas];
    this.isLoaded = true;
  }

  private explodeQrCodeToFindIDCourrier(mainCode: string): string {
    if (this.expressionReguliereWithiCourrierID.test(mainCode.toUpperCase())) {
      return mainCode.toUpperCase().replace(this.expressionReguliereWithiCourrierID, '$2');
    } else return null;
  }

  public selectUnselectAllCards(): void {
    if (this.allCardsSelected) {
      this.displayedDatas = this.displayedDatas.map((data) => {
        data.isChecked = false;
        return data;
      });
      this.allCardsSelected = false;
    } else {
      // Be careful here do not select the files without idCourrierFile
      this.displayedDatas = this.displayedDatas.map((data) => {
        data.idCourrierFile ? (data.isChecked = true) : (data.isChecked = false);
        return data;
      });
      this.allCardsSelected = true;
    }
  }

  public selectUnselectCardsTooltip(): string {
    return this.allCardsSelected ? this.translater.translate('iScan.action.unselectAll') : this.translater.translate('iScan.action.selectAll');
  }

  public isAnyScanSelected(): boolean {
    return this.displayedDatas.filter((data) => data.idCourrierFile).some((data) => data.isChecked);
  }

  public modifyListOfCheckedCards(index: number): void {
    this.displayedDatas[index].isChecked = !this.displayedDatas[index].isChecked;

    if (this.displayedDatas.filter((data) => data.idCourrierFile).every((data) => data.isChecked)) {
      this.allCardsSelected = true;
    } else this.allCardsSelected = false;
  }

  public submitAttachMass(): void {
    this.submitAttachmentLoader = true;
    this.spinner.show();

    this.scan.splits = this.scan.splits.map((split, index) => {
      const foundRightDisplayedData = this.displayedDatas.find((data) => data.splitIndex === index);
      if (foundRightDisplayedData?.isChecked) {
        split.lock = true;
      }
      return split;
    });

    this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
      next: () => {
        const scanLotProcessed = this.scan.splits.every((split) => split.lock);
        const data: AttachScanToExistingMailComponentParams[] = [];
        this.displayedDatas.forEach((dataForCard) => {
          if (dataForCard.isChecked) {
            data.push({
              lotGuid: this.originScan.guid,
              courrierId: +dataForCard.idCourrierFile,
              splitGuid: this.originScan.splits[dataForCard.splitIndex].guid,
              fileDescription: this.originScan.splits[dataForCard.splitIndex].name,
              barCode: this.originScan.splits[dataForCard.splitIndex].mainCode,
            });
          }
        });
        this.iCourrierScanService.massAttachScanToMail(scanLotProcessed, data).subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('thankYou'), this.translater.translate('iScan.success.successFilesAssociatedMail'));
            if (scanLotProcessed) {
              this.toastr.success(this.translater.translate('iScan.information.scanCompleted'), this.translater.translate('iScan.success.success'));
              this.spinner.hide();
              this.submitAttachmentLoader = false;
              this.router.navigateByUrl('private/ic/home-scans');
            } else {
              this.mailsService.searchMailsToAttach({ ids: data.map((d) => d.courrierId) }).subscribe({
                next: (mails) => {
                  let mailsWithSplitGuids = mails.map((mail) => {
                    return new ScanSearchMailsForBatchAttachment(mail);
                  });
                  mailsWithSplitGuids = mailsWithSplitGuids.map((mail) => {
                    mail.splitGuid = data.find((item) => item.courrierId === mail.id).splitGuid;
                    return mail;
                  });
                  this.submitAttachmentLoader = false;
                  this.closeModal.emit(mailsWithSplitGuids);
                },
              });
            }
          },
          error: () => {
            this.scan.splits = this.scan.splits.map((split, index) => {
              const foundRightDisplayedData = this.displayedDatas.find((data) => data.splitIndex === index);
              if (foundRightDisplayedData.isChecked) {
                split.lock = false;
              }
              return split;
            });
            this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe();
            this.toastr.error(this.translater.translate('errorOccurred'));
            this.spinner.hide();
            this.submitAttachmentLoader = false;
          },
        });
      },
    });
  }

  public emitCloseModal(): void {
    this.closeModal.emit();
  }
}
